import React from "react";
import { Box, Chip, Typography, useTheme } from "@mui/material";
import { SEOAnalysis } from "../../hooks/useSEOAnalysis";

interface SEOScoreGaugeProps {
  score: number;
  scoreLabel: SEOAnalysis["scoreLabel"];
  scoreColor: SEOAnalysis["scoreColor"];
}

const SIZE = 160;
const STROKE = 12;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

const SEOScoreGauge: React.FC<SEOScoreGaugeProps> = ({
  score,
  scoreLabel,
  scoreColor,
}) => {
  const theme = useTheme();
  const dashOffset = CIRCUMFERENCE * (1 - score / 100);
  const ringColor = theme.palette[scoreColor].main;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
      }}
    >
      <Box sx={{ position: "relative", width: SIZE, height: SIZE }}>
        <svg width={SIZE} height={SIZE} viewBox={`0 0 ${SIZE} ${SIZE}`}>
          <circle
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={RADIUS}
            fill="none"
            stroke={theme.palette.divider}
            strokeWidth={STROKE}
          />
          <circle
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={RADIUS}
            fill="none"
            stroke={ringColor}
            strokeWidth={STROKE}
            strokeLinecap="round"
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={dashOffset}
            transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
            style={{ transition: "stroke-dashoffset 0.3s ease" }}
          />
        </svg>
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="h3" fontWeight={800}>
            {score}
          </Typography>
          <Typography variant="caption" color="text.secondary">
            SCORE
          </Typography>
        </Box>
      </Box>
      <Chip
        label={scoreLabel}
        color={scoreColor}
        variant="filled"
        size="small"
      />
    </Box>
  );
};

export default SEOScoreGauge;
